import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from 'reactstrap';
import FontAwesomeIcon from '../../helpers/fontawesome/fontAwesome';

const ButtonIcon = ({ icon, iconAlign = 'left', iconClassName, transform, children, ...rest }) => {
  const showIcon = icon != null;

  return (
    <Button {...rest}>
      {iconAlign === 'right' && children}
      {showIcon && (
        <FontAwesomeIcon
          icon={icon}
          className={classNames(iconClassName, {
            'mr-1': children && iconAlign === 'left',
            'ml-1': children && iconAlign === 'right'
          })}
          transform={transform}
        />
      )}
      {iconAlign === 'left' && children}
    </Button>
  );
};

ButtonIcon.propTypes = {
  ...Button.propTypes,
  children: PropTypes.any,
  iconAlign: PropTypes.oneOf(['left', 'right']),
  iconClassName: PropTypes.string,
  transform: PropTypes.string
};


export default ButtonIcon;